<div class="col-sm-12" [formGroup]="experimentDesignFormGroup">
  <button
    class="btn btn-basic"
    (click)="fileInput.click()"
    [disabled]="crop === null || crop === undefined || treatmentCount === null || treatmentCount === undefined || treatmentCount < 1">
    <i class="fa fa-upload" aria-hidden="true"></i> Upload List
  </button>

  <input
    #fileInput
    class="hidden"
    type="file"
    accept=".csv"
    onclick="value = null"
    (change)="upload(fileInput.files)" />

  <button class="btn btn-primary" (click)="downloadTemplate()">
    <i class="fa fa-download" aria-hidden="true"></i> Download Template
  </button>

  <div *ngIf="seedNeeds.length === 0 && errors.length === 0" class="alert alert-warning seed-needs-alert-margin" role="alert">
    <i class="glyphicon glyphicon-alert"></i> Seed Needs template has not been uploaded
  </div>

  <div *ngIf="errors.length > 0" class="alert alert-danger seed-needs-alert-margin">
    <b>Errors</b>
    <ul>
      <li *ngFor="let error of errors">{{ error }}</li>
    </ul>
  </div>

  <div class="table-wrap-240" *ngIf="seedNeeds.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Entry Number</th>
          <th>SIID</th>
          <th>GE Name</th>
          <th>Number of Seeds/Cells</th>
          <th></th>
          <th *ngFor="let treatment of seedNeeds.at(0)['controls'].treatments['controls']">Treatment #{{treatment.value.treatmentNumber}}</th>
        </tr>
      </thead>
      <tbody formArrayName="seedNeeds">
        <tr *ngFor="let entry of seedNeeds.controls; let i=index;" formGroupName="{{i}}" [class.has-error]="entry.invalid">
          <td>{{ entry.value.entryNumber }}</td>
          <td>{{ entry.value.siid }}</td>
          <td>{{ entry.value.geName }}</td>
          <td>{{ entry.value.numberOfSeeds }}</td>
          <td><button
                *ngIf="i === 0 && seedNeeds.length > 1"
                type="button"
                class="btn btn-default"
                (click)="copyDown()">Copy Down</button>
          </td>
          <ng-container formArrayName="treatments">
            <td *ngFor="let treatment of entry['controls'].treatments['controls']; let t=index;" [formGroupName]="t">
              <input type="number" formControlName="seedCount" class="form-control"/>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/seed-needs-upload/seed-needs-upload.component.html